import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const bootUrl = new URL(window.location.href);
const routeFromQuery = bootUrl.searchParams.get("route");

// Fallback for static hosts that do not rewrite SPA routes:
// /admin/login/index.html can redirect to "/?route=/admin/login".
if (routeFromQuery && routeFromQuery.startsWith("/") && !routeFromQuery.startsWith("//")) {
  window.history.replaceState(null, "", routeFromQuery);
}

createRoot(document.getElementById("root")!).render(<App />);
